/** Marketing slug for the 30-minute program landing page */
export const LOP30_PROGRAM_SLUG = 'lop-30-minutter';

/** Signup campaign slug sent to the API when registering from the landing page */
export const LOP30_SIGNUP_CAMPAIGN = 'lop-30-minutter';

export const CREATE_ACCOUNT_LOP30_URL = `/create-account?campaign=${LOP30_SIGNUP_CAMPAIGN}`;

/** Marketing slug for the 4-week «kom i gang» program landing page */
export const LOP4UKER_PROGRAM_SLUG = 'kom-i-gang-4-uker';

/** Signup campaign slug sent to the API when registering from the 4-week landing page */
export const LOP4UKER_SIGNUP_CAMPAIGN = 'kom-i-gang-4-uker';

export const CREATE_ACCOUNT_LOP4UKER_URL = `/create-account?campaign=${LOP4UKER_SIGNUP_CAMPAIGN}`;

const frontendBase = process.env.REACT_APP_FRONTEND_URL || 'https://lopeglad.no';

/** Program id for «Løp 30 minutter» in the app */
export const LOP30_PROGRAM_ID = process.env.REACT_APP_LOP30_PROGRAM_ID || '68';

/** Program id for «Kom i gang på 4 uker» in the app */
export const LOP4UKER_PROGRAM_ID = process.env.REACT_APP_LOP4UKER_PROGRAM_ID || '46';

export function getLop30ProgramDeepLink() {
  if (LOP30_PROGRAM_ID) {
    return `lopeglad://programs/${LOP30_PROGRAM_ID}`;
  }
  return `lopeglad://program/${LOP30_PROGRAM_SLUG}`;
}

export function getLop30ProgramUniversalUrl() {
  if (LOP30_PROGRAM_ID) {
    return `${frontendBase}/programs/${LOP30_PROGRAM_ID}`;
  }
  return `${frontendBase}/program/${LOP30_PROGRAM_SLUG}`;
}

export function getLop4UkerProgramDeepLink() {
  if (LOP4UKER_PROGRAM_ID) {
    return `lopeglad://programs/${LOP4UKER_PROGRAM_ID}`;
  }
  return `lopeglad://program/${LOP4UKER_PROGRAM_SLUG}`;
}

export function getLop4UkerProgramUniversalUrl() {
  if (LOP4UKER_PROGRAM_ID) {
    return `${frontendBase}/programs/${LOP4UKER_PROGRAM_ID}`;
  }
  return `${frontendBase}/program/${LOP4UKER_PROGRAM_SLUG}`;
}
